// storage.service.js

export const getThisState = (stateName) => {
  try{
    const serializedState = sessionStorage.getItem(stateName);
    if(serializedState === null){ return undefined }
    return JSON.parse(serializedState);
  } catch(err){
    return undefined
  }
}

export const getItem = (itemName) => {
  const items = getThisState(itemName)
  if (items === undefined) {
    return {}
  } else {
    return items
  }
}

export const saveItem = (key,data) => {
  const serializedState = JSON.stringify(data);
  sessionStorage.setItem(key,serializedState);
}

export const getItemByKey = (key) => {
  try{
    const serializedState = sessionStorage.getItem(key);
    if(serializedState === null){ return undefined }
    return JSON.parse(serializedState);
  }catch(err){
    return undefined
  }
}

export const deleteItemByKey = (key) => sessionStorage.setItem(key,null)

export default {
  getThisState: getThisState,
  saveItem :saveItem,
  getItemByKey : getItemByKey,
  deleteItemByKey : deleteItemByKey,
}
